import { render, staticRenderFns } from "./mobileBorrowerLoanItem.vue?vue&type=template&id=baf78112&scoped=true&"
import script from "./mobileBorrowerLoanItem.vue?vue&type=script&lang=js&"
export * from "./mobileBorrowerLoanItem.vue?vue&type=script&lang=js&"
import style0 from "./mobileBorrowerLoanItem.vue?vue&type=style&index=0&id=baf78112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf78112",
  null
  
)

export default component.exports